import { ReactElement } from 'react'
import { GroupBy } from 'app/components/viz/DateGroupSelector'

const PERIOD_LABEL: Record<GroupBy, string> = {
  days: `Today`,
  weeks: `This week`,
  months: `This month`,
}

/** Legend entry explaining `BarStackGraph`'s dashed divider before a still-filling last bar. */
export function InProgressLegend({ group }: { group: GroupBy }): ReactElement {
  return (
    <span className="flex items-center gap-1.5 self-center text-body-xs text-subtle">
      <span className="h-3 border-l-2 border-dashed border-strong" />
      {`${PERIOD_LABEL[group]} in progress`}
    </span>
  )
}
